import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "#18191d", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 12, y1: 5, x2: 12, y2: 19 }), /* @__PURE__ */ React.createElement("line", { x1: 5, y1: 12, x2: 19, y2: 12 }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
